import React from "react";

const ReviewsComponent = (props) => {
    const { Renderer } = props;

    return <Renderer {...props} />;
};

export default ReviewsComponent;
